// Dependencias
import axios from 'axios';
import { URL_API } from '../config/keys.config';

// Utils
import { httpTokenInterceptor } from '../utils/httpTokenInterceptor';

// Instancias
const token = document.querySelector<HTMLInputElement>('#access-token')!.value;
const clientAxios = axios.create({
  baseURL: URL_API,
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`
  }
});

clientAxios.interceptors.response.use((res) => res, httpTokenInterceptor);

/**
 * Obtiene los datos de KPIs mensuales
 */
export async function fetchKPIData(): Promise<KPIData[] | null> {
  try {
    const { data: kpisData } = await clientAxios.get<KPIData[]>('/kpis');
    return kpisData;
  } catch (error) {
    console.error('Error fetching KPI data:', error);
    return null;
  }
}
type SignatureWithoutAccount = {
  numberOfUsers: number;
  typeOfSignOwner: string;
};
type SignatureWithGuesOrWithoutGuest = {
  Tipo_de_firma: string;
  Cuentas_que_han_firmado: number;
};
type DocumentStatus = {
  status: string;
  deleted_count: string;
  regular_count: string;
  trashed_count: string;
};
export type KPIData = {
  month: string;
  total_accounts: number;
  total_uploaded_documents: number;
  accounts_no_upload_documents: number;
  new_accounts_created: number;
  signatories_without_account_by_type: SignatureWithoutAccount[];
  signatories_with_guests_or_without_guest: SignatureWithGuesOrWithoutGuest[];
  signatories_without_account: number;
  document_signed: number;
  average_documents_signed: number;
  user_buyers: number;
  document_status: DocumentStatus[];
  total_document_uploaded: number;
  users_upload_but_no_sign: number;
  available_documents_for_sale: number;
  documents_assigned: number;
  assigned_but_not_used_documents: number;
  used_documents: number;
  historical_recurrent_users: number;
  monthly_recurrent_users: number;
  total_blockchain_documents: number;
  // Campos nuevos (pueden venir nulos hasta fin de mes)
  users_by_plan?: Record<string, number> | Array<{ plan: string; users: number }> | null;
  signatures_by_type?: Record<string, number> | Array<{ type: string; total: number }> | null;
  saldo_folios_usuarios?: number | null;
  purchases_by_plan?: Record<string, number> | Array<{ plan: string; purchases: number }> | null;
  sales_mxn?: number | null;
};
